/* eslint-disable no-unused-vars */
import {
  ASSET_TYPES,
  ENGINE_COMPONENT_TYPES,
  ASPECT_RATIO_LIST,
} from "../constants";
import { triggerAssetDownloadIfAny } from "../modules/EngineUtils";
import { saveSKUData } from "../modules/SKUClient";
import {
  getConfigByPlatform,
  updatePlatformConfig,
  updateOnLoadConfig,
  removeEmptySelections,
  createFinalOnLoadConfig,
} from "../components/engine/utils/configHelper";

export const topLevelButtonPresets = [
  {
    name: "fullEmptyIcon",
    menu: [],
    icon: "https://d179blwxwzk8ou.cloudfront.net/common/Pepperfry_Icons_Full.png",
    iconSelected:
      "https://d179blwxwzk8ou.cloudfront.net/common/Pepperfry_Icons_Empty.png",
  },
  {
    name: "dimensionIcon",
    menu: [],
    icon: "https://d179blwxwzk8ou.cloudfront.net/common/Pepperfry_Icons_Dimensions-On.png",
    iconSelected:
      "https://d179blwxwzk8ou.cloudfront.net/common/Pepperfry_Icons_Dimensions-Off.png",
  },
  {
    name: "colorChangeIcon",
    menu: [],
    icon: "https://d179blwxwzk8ou.cloudfront.net/common/Pepperfry_Icons_Colour.png",
    iconSelected:
      "https://d179blwxwzk8ou.cloudfront.net/common/Pepperfry_Icons_Colour-2.png",
  },
  {
    name: "openCloseIcon",
    menu: [],
    icon: "https://d179blwxwzk8ou.cloudfront.net/common/Pepperfry_Icons_Open.png",
    iconSelected:
      "https://d179blwxwzk8ou.cloudfront.net/common/Pepperfry_Icons_Close.png",
  },
  {
    name: "lightOnOffIcon",
    menu: [],
    icon: "https://d179blwxwzk8ou.cloudfront.net/common/On.png",
    iconSelected: "https://d179blwxwzk8ou.cloudfront.net/common/Off.png",
  },
];
export const colorButtonPresets = [
  {
    name: "Sandy",
    menu: [],
    icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/sandy/Sandy.png",
    iconSelected:
      "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/sandy/Sandy_Selected.png",
  },
  {
    name: "Beige",
    menu: [],
    icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/beige/Beige.png",
    iconSelected:
      "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/beige/Beige_Selected.png",
  },
  {
    name: "DenimBlue",
    menu: [],
    icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/denimblue/Denim+Blue.png",
    iconSelected:
      "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/denimblue/Denim+Blue_Selected.png",
  },
  {
    name: "Blue",
    menu: [],
    icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/blue/Blue.png",
    iconSelected:
      "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/blue/Blue_Selected.png",
  },
  {
    name: "Charcoal",
    menu: [],
    icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/charcoal/Charcoal.png",
    iconSelected:
      "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/charcoal/Charcoal_Selected.png",
  },
  {
    name: "ChestnutBrown",
    menu: [],
    icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/chestnutbrown/Chestnut+Brown.png",
    iconSelected:
      "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/chestnutbrown/Chestnut+Brown_Selected.png",
  },
  {
    name: "Grey",
    menu: [],
    icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/grey/Grey.png",
    iconSelected:
      "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/grey/Grey_Selected.png",
  },
  {
    name: "Red",
    menu: [],
    icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/red/Red.png",
    iconSelected:
      "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/red/Red_Selected.png",
  },
  {
    name: "Redish",
    menu: [],
    icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/red/Red.png",
    iconSelected:
      "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/red/Red_Selected.png",
  },
  {
    name: "Rediiiii",
    menu: [],
    icon: "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/red/Red.png",
    iconSelected:
      "https://royalenfield.s3.ap-south-1.amazonaws.com/pepperfry/coloricons/red/Red_Selected.png",
  },
];

export const pepperfryButtonConfigs = [
  {
    name: "dimensionIcon",
    actions: {
      onClick: [ENGINE_COMPONENT_TYPES.OPACITY_COMPONENT],
      onUnClick: [ENGINE_COMPONENT_TYPES.OPACITY_COMPONENT],
      onSlot: [],
    },
    correlation: {
      iconName: "openCloseIcon",
      default: false,
      onClick: true,
      onUnClick: false,
    },
  },
  {
    name: "colorChangeIcon",
    actions: {
      onClick: [],
      onUnClick: [],
      onSlot: [ENGINE_COMPONENT_TYPES.ADD_SLOTS],
    },
    getOptions: () => colorButtonPresets,
    correlation: null,
    children: {
      actions: {
        onClick: [ENGINE_COMPONENT_TYPES.MATERIALS_COMPONENT],
        onUnClick: [],
        onSlot: [],
      },
    },
  },
  {
    name: "fullEmptyIcon",
    actions: {
      onClick: [
        ENGINE_COMPONENT_TYPES.OPACITY_COMPONENT,
        ENGINE_COMPONENT_TYPES.CLIP_ANIMATION_COMPONENT,
      ],
      onUnClick: [
        ENGINE_COMPONENT_TYPES.OPACITY_COMPONENT,
        ENGINE_COMPONENT_TYPES.CLIP_ANIMATION_COMPONENT,
      ],
    },
    correlation: {
      iconName: "openCloseIcon",
      default: true,
      onClick: true,
      onUnClick: true,
    },
  },
  {
    name: "lightOnOffIcon",
    actions: {
      onClick: [ENGINE_COMPONENT_TYPES.MATERIALS_COMPONENT],
      onUnClick: [ENGINE_COMPONENT_TYPES.MATERIALS_COMPONENT],
    },
    correlation: null,
  },
  {
    name: "openCloseIcon",
    actions: {
      onClick: [ENGINE_COMPONENT_TYPES.CLIP_ANIMATION_COMPONENT],
      onUnClick: [ENGINE_COMPONENT_TYPES.CLIP_ANIMATION_COMPONENT],
    },
    correlation: null,
  },
];

const hdriOptions = [
  {
    name: "Studio_05_180",
    lightURL:
      "https://developers-test-ap-south-1.s3.ap-south-1.amazonaws.com/testAssets/Studio-05_converted.hdr",
    exposure: 0.1,
    type: ASSET_TYPES.HDRI,
  },
  {
    name: "Studio_05",
    lightURL:
      "https://developers-test-ap-south-1.s3.ap-south-1.amazonaws.com/testAssets/Studio-05_converted.hdr",
    type: ASSET_TYPES.HDRI,
    exposure: 5,
  },
  {
    name: "Studio_05_1",
    lightURL:
      "https://d77dh4faztz32.cloudfront.net/hdrs/small_cathedral_256.hdr",
    type: ASSET_TYPES.HDRI,
    exposure: 5,
  },
  {
    name: "HDR_CUBEMAP",
    type: "CUBE_MAP",
    exposure: 5,
    lightURL: "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/",
    urls: [
      "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/px.png",
      "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/nx.png",
      "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/py.png",
      "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/ny.png",
      "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/pz.png",
      "https://d77dh4faztz32.cloudfront.net/cubemap/studio5exposure1/nz.png",
    ],
  },
];

const sortUIConfigButton = (
  config,
  sortOrder = [
    "dimensionIcon",
    "colorChangeIcon",
    "openCloseIcon",
    "fullEmptyIcon",
    "lightOnOffIcon",
  ]
) => {
  const sortedMenuConfig = [];
  sortOrder.forEach((actionType) => {
    const menuConfig = config?.menu?.find((e) => e.name === actionType);
    if (menuConfig && menuConfig.enabled !== false) {
      const updatedMenuConfig = removeEmptySelections(menuConfig);

      if (actionType === "colorChangeIcon") {
        const updatedChildConfig = menuConfig.menu
          .filter((m) => menuConfig.enabled !== false)
          .map((subMenu) => {
            const updatedChildMenu = removeEmptySelections(subMenu);
            return { ...subMenu, ...updatedChildMenu };
          });
        updatedMenuConfig.menu = updatedChildConfig;
      }
      sortedMenuConfig.push({ ...menuConfig, ...updatedMenuConfig });
    }
  });

  return sortedMenuConfig;
};

export const getPepperfryTemplate = ({ skuId, clientId }, actions) => ({
  templateId: "pepperfry_1",
  submitSkuConfig: () => {
    const config = actions.ConfigBuilder.getSKUConfig(skuId);
    if (config.uiConfig && config.uiConfig.menu) {
      config.uiConfig.menu = sortUIConfigButton(config.uiConfig);
    }
    if (config.uiConfig && config.uiConfig.onLoad) {
      config.uiConfig.onLoad = createFinalOnLoadConfig(config.uiConfig.onLoad);
    }
    config.updatedTimeStamp = Math.floor(Date.now() / 1000);
    if (!config.iconCorrelationV2) {
      config.iconCorrelationV2 = true;
    }
    console.log("🚀 ~ file: pepperfryTemplate.js ~ line 263 ~ config", config);
    saveSKUData(config, skuId, clientId);
  },
  enableRendererPreview: () => {
    const config = actions.ConfigBuilder.getSKUConfig(skuId);
    return !!config?.updatedTimeStamp;
  },
  enableDefaultButtonConfig: true,
  updateDefaultButtonConfig: (value) => {
    actions.ConfigBuilder.setDefaultOnLoadButton(skuId, value);
  },
  getDefaultButtonConfig: () =>
    actions.ConfigBuilder.getSKUConfig(skuId).uiConfig.default,
  updateAssetsLoadingState: (loading) =>
    actions.useEngineStore.getState().setAssetLoadingState(loading),
  getOnLoadConfig: () =>
    actions.ConfigBuilder.getSKUConfig(skuId)?.uiConfig?.onLoad,
  getConfigByPlatform,
  updatePlatformConfig,
  updateOnLoadConfig,
  components: [
    {
      title: "General",
      enabled: true,
      enableActions: true,
      type: ENGINE_COMPONENT_TYPES.NAV_ICON,
      icon: "GeneralIcon",
      activeIcon: "GeneralIconActive",
      components: [
        {
          title: "Color Configurations",
          type: ENGINE_COMPONENT_TYPES.BACKGROUND_COLOR,
          changeBackgroundColor: (config) => {
            const { scene } = actions.ThreejsScene.getSceneDetails();
            actions.ThreejsScene.changeBackgroundColor(scene, config);
          },
          getCurrentConfig: () =>
            actions.ConfigBuilder.getSKUConfig(skuId).backgroundColor,
          updateConfig: (config) => {
            actions.ConfigBuilder.getSKUConfig(skuId).backgroundColor = config;
          },
        },
        // {
        //   title: "Guidelines",
        //   type: ENGINE_COMPONENT_TYPES.AXES_HELPERS,
        //   addHelpers: actions.ThreejsScene.addHelpers,
        //   removeHelpers: actions.ThreejsScene.removeHelpers,
        //   getSceneChildrens: () =>
        //     actions.ThreejsScene.getSceneDetails()
        //       .scene.children.filter((e) =>
        //         [
        //           THREEJS_NAMES.MODEL,
        //           THREEJS_NAMES.DIRECTIONAL_LIGHT,
        //           THREEJS_NAMES.AMBIENT_LIGHT,
        //         ].includes(e.name)
        //       )
        //       .map((e1) => [e1.name, e1.uuid]),
        // },
      ],
    },
    {
      title: "Lighting Settings",
      enabled: false,
      enableActions: true,
      type: ENGINE_COMPONENT_TYPES.NAV_ICON,
      icon: "LightBulb",
      activeIcon: "LightBulb",
      components: [
        {
          title: "Ambient Light",
          type: ENGINE_COMPONENT_TYPES.AMBIENT_LIGHT,
          applyAmbientLight: (config) => {
            const { scene } = actions.ThreejsScene.getSceneDetails();
            actions.ThreejsScene.updateAmbientLight(scene, config);
          },
          updateConfig: (config) => {
            actions.ConfigBuilder.getSKUConfig(skuId).ambientLight = config;
          },
          getCurrentConfig: () =>
            actions.ConfigBuilder.getSKUConfig(skuId).ambientLight,
        },
        // {
        //   title: "Directional Lights",
        //   type: ENGINE_COMPONENT_TYPES.DIRECTIONAL_LIGHT,
        //   addDirectionalLight: actions.ThreejsScene.addDirectionalLight,
        //   getCurrentConfig: () =>
        //     actions.ConfigBuilder.getSKUConfig(skuId).directionalLights,
        // },
        {
          title: "Environment Lights",
          type: ENGINE_COMPONENT_TYPES.ENVIRONMENT_LIGHT,
          updateEnvironmentLight: async (lightConfig) => {
            console.log("applyEnvironmentLight", lightConfig.lightURL);
            lightConfig.lightURL = await triggerAssetDownloadIfAny(
              actions,
              lightConfig,
              skuId
            );
            const { scene, renderer } = actions.ThreejsScene.getSceneDetails();
            actions.ThreejsScene.updateEnvironmentLight(
              scene,
              renderer,
              lightConfig,
              actions.AssetLoader.getAsset
            );
            actions.ARModels.updateEnvMapIntensity("abc", lightConfig.exposure);
            return lightConfig;
          },
          applyEnvironmentIntensity: (intensity) => {
            actions.ARModels.updateEnvMapIntensity("abc", intensity);
          },
          getCurrentConfig: () =>
            actions.ConfigBuilder.getSKUConfig(skuId).environmentLight,
          updateConfig: (config) => {
            console.log("environment light update config", config);
            actions.ConfigBuilder.getSKUConfig(skuId).environmentLight = config;
          },
          getHDRIOptions: () => hdriOptions,
        },
      ],
    },
    {
      title: "3D Interactivity",
      enabled: true,
      enableActions: true,
      type: ENGINE_COMPONENT_TYPES.NAV_ICON,
      icon: "InteractivityIcon",
      activeIcon: "InteractivityIconActive",
      components: [
        {
          title: "3D Interactivity",
          type: ENGINE_COMPONENT_TYPES.INTERACTIVITY,
        },
      ],
    },
    {
      title: "Viewport",
      enabled: true,
      enableActions: false,
      type: ENGINE_COMPONENT_TYPES.NAV_ICON,
      icon: "ViewPort",
      activeIcon: "ViewPort",
      components: [
        {
          title: "Viewport",
          type: ENGINE_COMPONENT_TYPES.ASPECT_RATIO_COMPONENT,
          getAspectRatioList: () => ASPECT_RATIO_LIST,
          setCamera: () => actions.ThreejsScene.setCameraConfig,
        },
      ],
    },
    {
      title: "Product Info",
      enabled: false,
      enableActions: false,
      type: ENGINE_COMPONENT_TYPES.NAV_ICON,
      icon: "InfoIcon",
      activeIcon: "InfoIconActive",
      components: [
        {
          title: "Product Info",
          type: ENGINE_COMPONENT_TYPES.PRODUCT_INFO,
          getInfo: () => {
            // call supernova
          },
        },
      ],
    },
  ],
});
